<template>
<router-link class="featured-chatperson" :to="to">

  <div class="flex-box">
      <h2 class="title">{{item.name}}</h2>
      <div class="date">{{createChatDate(item.last_chat.datetime)}}</div>
  </div>

  <div class="flex-box">
    <img @error="imgLoadError" class="img-icon" :src="getAvatarSrc(item)">
    
      <div class="text">
            <div>{{createExcerpt(item)}}</div>
            <div class="sub">
              <ui-chip backgroundColor="#888888"  class="chip-child" icon="child" v-for="(item, index) in item.children" :key="index">
                {{item.name}}:{{item.group.toLowerCase()}}
              </ui-chip>
              <ui-chip backgroundColor="#50c0db"  class="chip-child" icon="users" v-for="(item, index) in item.teach_groups" :key="index">
                {{item}}
              </ui-chip>
            </div>
      </div>

  </div>

    </router-link>
</template>

<script>


//import UiIcon from '../UiIcon.vue';
import { helper } from '../../services/Helper.js';
import UiChip from '../../components/UiChip.vue';

export default {
  name: 'button-chat-person-featured',
  props:{
    to:{default:"/"},
    item:{default:undefined},
    index:{default:0},
  },
  data:function(){
    return {
    }
  },
  components:{
    UiChip,
  },
  methods:{
    createChatDate(dateString){
      return helper.convertChatDate(dateString);
    },
    getAvatarSrc(item){
      var timestamp="?ts="+new Date().getTime();
      
      //return item.avatar ? item.avatar+timestamp : undefined;
      return item.avatar ? item.avatar+timestamp : this.composeReactionAvatar(item);
    },
    createExcerpt(item){

      var excerpt=helper.getExcerpt(item.last_chat.message,"...",150)
      return excerpt;
      
    },
    composeReactionAvatar(item){

      return helper.composeAvatarImage(item.name);

    },
    imgLoadError(event){
      
      event.target.src=require('../../assets/default_avatar.png');
    },
    
  },
  computed:{
    
    computePosterStyle(){
      if(this.index==0){
        // big news poster
        //return {width:'100%!important',marginBottom:'10px!important'}
      }
      return {};
    }
  },
  mounted:function(){
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sub{
 margin-top:6px;
}
.chip-child{
  line-height: 1em;
  font-size: .8em;
  margin-right:2px;
  margin-bottom:2px;
  display: inline-block;
}

.featured-chatperson{
  text-decoration: none;
  cursor:pointer;
  color:inherit;
  display:block;
  position:relative;
}

.flex-box{
  display:flex;
  justify-content: center;
}
.title{
  flex:1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text{
  word-break:break-word;
  line-height:1.1em;
  flex:1;
  margin-left:8px;
}

img{
  border-radius:2px;
}

.clear-float{
  clear:both;
}

h2{
  margin:0px;
  margin-bottom:10px;
  font-size:1.2em;
  line-height:1em;
}


.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
.date{
  font-size:.8em;
  color:#C4C4C4;
  padding-left:4px;
}
</style>

